<template>
  <loader v-if="dataLoading" />
  
  <div class="page">
    <div class="flex justify-content-center">
      <div class="grid">
        <div class="grid">
          <div class="col p-as-end">
            <i></i>
            <br>
            <span class="p-input-icon-left">
              <i class="pi pi-filter" />
              <input-number 
              v-model="filter" 
              showButtons buttonLayout="horizontal" 
              inputStyle="text-align:center;"
              :step="1"
              decrementButtonClass="p-button-danger" 
              incrementButtonClass="p-button-success" 
              incrementButtonIcon="pi pi-plus" 
              decrementButtonIcon="pi pi-minus"
              :useGrouping="false"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
    <DataTable :value="data.stats" responsiveLayout="scroll">
      <column field="start_date" header="Mese">
        <template #body="{data}">
          {{ (data.start_date !== null) ? moment(data.start_date).locale('it').format('MMMM YYYY').toUpperCase(): '' }}
        </template>
      </column>
      <column field="importo" header="Importo Bollo">
        <template #body="{data}">
          {{currencyFormatter.format( data.importo)}}
        </template>
      </column>
      <column :exportable="false">
        <template #body="{data}">
          <prime-button 
          icon="pi pi-search" 
          class="p-button-rounded p-button-info mr-2" 
          @click="ViewReport(data)" 
          />
        </template>
      </column>
      
    </DataTable>
  </div>
  <Dialog header="Riepilogo Fatture" v-model:visible="showDialog" modal maximizable :style="{width: '50vw'}">
    <div class="container">
      <p> Mese: <strong>{{moment(dataToShow.start_date).locale('it').format('MMMM YYYY').toUpperCase()}}</strong></p>
      <p> Importo Bollo: <strong>{{currencyFormatter.format(dataToShow.importo)}}</strong></p>
    </div>
    <DataTable :value="dataToShow.fatture" responsiveLayout="scroll">
      <column field="index" header="Indice">
      </column>
      
      <column field="numero_fattura" header="Numero Fattura">
      </column>
      <column field="totale_fattura" header="Importo Fattura">
        <template #body="{data}">
          {{currencyFormatter.format( data.totale_fattura)}}
        </template>
        
      </column>
    </DataTable>
  </Dialog>
  </template>
  <script>
  import moment from 'moment'
  
  import Service from '@/services/ask-management/utility-bollo-service'
  
  import Loader from '@/components/Loader.vue'
  import PrimeButton from 'primevue/button'
  import Dialog from 'primevue/dialog';
    export default { 
    components: {
      Loader,
      PrimeButton,
      Dialog
    },
  
    data() {
      return {
        moment,
        showDialog: false,
        dataToShow:[],
        currencyFormatter: new Intl.NumberFormat('it-IT', {
          style: 'currency',
          currency: 'EUR',
        }),
  
        dataLoading: false,
        filter: new Date().getFullYear(),
  
        data: {
          stats: []
        },
      }
    },
  
    created(){
      this.service = new Service(this.$http, this.$eventBus)
      this.getStatistiche()
    },
  
    methods:{
      getRowClass(rowData) {
        return { 'red-text': rowData.data.numero_fattura < 0 };
      },  
      ViewReport(data){
        this.dataToShow = data;
          this.showDialog = true
          return data
        
          // this.service.downloadFileCsv(date)
      },

      navigateToTab(href){
        window.open(href, '_blank')
      },
  
      applyFilter(filter){
        const length = filter.toString().length
        if(length == 4){
          this.getStatistiche()
        }
      },
  
      getStatistiche(){
        this.dataLoading = true  

        this.service.getStatisticheByYear(this.filter)
        .then((res) => {
          this.data.stats = res
        })
        .catch(() => {
          console.error();
        })
        .finally(() =>{
          this.dataLoading = false
        })
      }
  
    },
  
    computed:{
      
    },
  
    watch: {
      filter(newVal) {
        this.applyFilter(newVal)
      },
    },
  }
  </script>
  
  <style scoped>
  .box-center{
    text-align: center;
    font-size: 24px;
  }
  .bold{
    font-weight:bold;
  }

  .container{
    display: flex;
    justify-content: space-around;
  }
  </style>
  